module.exports = __webpack_public_path__ + "static/media/POSS_Getting_Started.1936782.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documents/POSS_Getting_Started.pdf
// module id = qZri
// module chunks = 1